import React, { useContext, useState } from 'react'
import {
  createFormattedDateFromDate,
  createFormattedDateFromStr,
  dayDiff
} from './helpers/dateFunctions'
import CellRow from './CellRow'
import { DataContext, StyleContext } from './GanttChart'

const TaskRows = () => {
  const { tasks, setTasks, curYear, curMonth, numDays, handleDragEvent } =
    useContext(DataContext)
  const { columnValue, lockHeight } = useContext(StyleContext)

  const ganttTimePeriod = {
    display: 'grid',
    gridAutoFlow: 'column',
    gridAutoColumns: `minmax(${columnValue}px, 1fr)`,
    outline: '0.5px solid #e9eaeb',
    textAlign: 'center',
    height: `${lockHeight ? 72 : Math.floor(columnValue / 1.33)}px`,
    minHeight: '40px'
  }

  const [taskDurationElDraggedId, setTaskDurationElDraggedId] = useState(null)
  // const numMonths = monthDiff(startMonth, endMonth) + 1;
  let taskRows = []
  let taskRow = []
  // create task rows
  if (tasks) {
    tasks.forEach((task) => {
      let nd = new Array(
        dayDiff(task?.start.substr(0, 10), task?.end.substr(0, 10))
      ).fill(0)

      for (let j = 1; j <= numDays; j++) {
        const formattedDate = createFormattedDateFromStr(curYear, curMonth, j)

        // creating row cells for each task
        taskRow.push(
          <div
            id={`${task.id}-${j}`}
            key={`${task.id}-${j}`}
            style={{
              ...ganttTimePeriodCell,
              backgroundColor:
                formattedDate === createFormattedDateFromDate(new Date())
                  ? '#E5F1FA'
                  : '#fff',

              padding: '5px'
            }}
            data-task={task?.id}
            data-date={formattedDate}
            onDrop={onTaskDurationDrop}
          >
            <CellRow color='' />
            <CellRow color='' />
            <CellRow color='' />
            {/* new logic */}
            {task.start.substr(0, 10) === formattedDate && (
              <div
                key={`${j}-${task?.id}`}
                tabIndex='0'
                draggable='true'
                onDragStart={() => handleDragStart(task?.id)}
                style={{
                  ...taskDuration,
                  width: `calc(${dayDiff(
                    task?.start.substr(0, 10),
                    task?.end.substr(0, 10)
                  )} * 100% - 0px )`,
                  bottom: '-1px',
                  left: '0px',
                  display: 'grid',
                  gridAutoFlow: 'column',
                  gridAutoColumns: `minmax(${columnValue}px, 1fr)`,
                  height: `${
                    lockHeight ? 70 : Math.round(columnValue / 1.43) + 1
                  }px`,
                  outline: '2px solid #090A0B'
                }}
              >
                {nd.map((d, i) => (
                  <div
                    id={`${task.id}-${j}-${i}`}
                    key={`${task.id}-${j}-${i}`}
                    style={{
                      ...ganttTimePeriodCell,
                      padding: '3px',
                      outline: 'none'
                    }}
                    data-task={task?.id}
                    data-date={formattedDate}
                    draggable={false}
                  >
                    {task.cranes.map((r) => (
                      <CellRow key={r.id} color={r.color} />
                    ))}
                  </div>
                ))}
              </div>
            )}
          </div>
        )
      }

      taskRows.push(
        <div key={`${1}-${task?.id}`} style={ganttTimePeriod} id='taskrows'>
          {taskRow}
        </div>
      )
      taskRow = []
    })
  }

  function handleDragStart(taskDurationId) {
    setTaskDurationElDraggedId(taskDurationId)
  }

  function onTaskDurationDrop(e) {
    // console.log("first", e.target);
    let targetCell = e.target.parentElement.parentElement.parentElement
    if (
      e.target.parentElement.parentElement.parentElement.hasAttribute(
        'data-task'
      )
    ) {
      targetCell = e.target.parentElement.parentElement.parentElement
    } else if (e.target.hasAttribute('data-task')) {
      targetCell = e.target
    } else if (e.target.parentElement.hasAttribute('data-task')) {
      targetCell = e.target.parentElement
    } else if (e.target.parentElement.parentElement.hasAttribute('data-task')) {
      targetCell = e.target.parentElement.parentElement
    } else {
      targetCell = e.target.parentElement.parentElement.parentElement
      console.log('object', targetCell)
    }

    // prevent adding on another taskDuration
    if (!targetCell.hasAttribute('draggable')) {
      // find task
      const taskDuration = tasks.filter(
        (taskDuration) => taskDuration.id === taskDurationElDraggedId
      )[0]

      const dataTask = targetCell.getAttribute('data-task')
      const dataDate = targetCell.getAttribute('data-date')
      if (dataTask == taskDuration.id) {
        const daysDuration = dayDiff(
          taskDuration.start.substr(0, 10),
          taskDuration.end.substr(0, 10)
        )
        const newTask = parseInt(dataTask)
        const newStartDate = new Date(dataDate)
        let newEndDate = new Date(dataDate)
        newEndDate.setDate(newEndDate.getDate() + daysDuration - 1)

        taskDuration.start = newStartDate.toISOString()
        taskDuration.end = newEndDate.toISOString()
        // console.log("n taskDuration", taskDuration);
        const newTaskDurations = tasks.filter(
          (taskDuration) => taskDuration.id !== taskDurationElDraggedId
        )
        newTaskDurations.push(taskDuration)
        handleDragEvent(taskDuration)
        // console.log('to update', taskDuration)
        setTasks(
          newTaskDurations.sort(function (a, b) {
            if (a.id < b.id) {
              return -1
            }
            if (a.id > b.id) {
              return 1
            }

            return 0
          })
        )
      } else {
        console.log('Diff')
        alert('You cannot drag on to another job! ')
      }
    }
    setTaskDurationElDraggedId(null)
  }
  return (
    <div
      id='gantt-time-period-cell-container'
      style={{
        gridColumn: '1/-1',
        display: 'grid',
        // gridTemplateColumns: `repeat(${numMonths}, 1fr)`,
        paddingLeft: '0.5px',
        zIndex: '-1'
      }}
      onDragOver={(e) => e.preventDefault()}
    >
      {taskRows}
    </div>
  )
}

export default TaskRows

// styling
const ganttTimePeriodCell = {
  position: 'relative',
  outline: '2px solid #cecece',
  marginTop: '0.5px',
  backgroundColor: '#EEEEEE'
}

const taskDuration = {
  position: 'absolute',
  height: 'calc(65px - 5px)',
  zIndex: '1',
  boxShadow: '3px 3px 3px rgba(0, 0, 0, 0.05)',
  cursor: 'move'
}
